var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 5.99985C13.6667 6.27485 13.4719 6.49986 13.1997 6.49986H1.94693L6.14394 11.1656C6.32759 11.3697 6.31259 11.6862 6.1106 11.8716C6.01497 11.9562 5.89435 12 5.77682 12C5.64246 12 5.50811 11.9453 5.41062 11.8359L0.462045 6.33579C0.290484 6.14535 0.290484 5.85422 0.462045 5.6639L5.41062 0.163759C5.59524 -0.0413091 5.90826 -0.054997 6.10992 0.12957C6.31191 0.315137 6.32691 0.631458 6.14326 0.835526L1.94693 5.49983H13.1997C13.4719 5.49983 13.6667 5.72484 13.6667 5.99985Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.89fe74b3edd98a1e6a18f7f5287d3baa.svg";
export { ForwardRef as ReactComponent };